export const tableFontSize = {
	headerSize: '14px',
	headerWeight: 500,
	cellSize: '13px',
	cellWeight: 400,
};

export const inboxTableFontSize = {
	headerSize: '16px',
	headerWeight: 600,
	cellSize: '14px',
	cellWeight: 500,
};
